import { cn } from '../../lib/cn';
import type { CourseRow } from '../../knowledgecenter/framework';

type Props = { courses?: CourseRow[] };

export function LearningAcademyPanel({ courses = [] }: Props) {
  return (
    <div className="space-y-2">
      {courses.map((c) => (
        <div key={c.title} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium">{c.title}</p>
              <p className="mt-0.5 text-xs text-slate-500">{c.module} · {c.enrolled} enrolled</p>
            </div>
            {c.certified && (
              <span className="shrink-0 rounded-full bg-success-50 px-2 py-0.5 text-xs font-medium text-success-700 dark:bg-success-950 dark:text-success-300">
                certified
              </span>
            )}
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full', c.progress === 100 ? 'bg-success-500' : 'bg-brand-500')} style={{ width: `${c.progress}%` }} />
          </div>
          <p className="mt-1 text-xs text-slate-500">{c.progress}% complete</p>
        </div>
      ))}
    </div>
  );
}
